<script lang="ts">
  import type { BetfairMarket } from '$types/races';
  import { formatTotalMatched } from '$utils/prices';
  import type { Readable } from 'svelte/store';

  export let betfairMarketStore: Readable<BetfairMarket>;
</script>

<td class="border-x px-1 py-1 font-medium text-gray-700"
  >{formatTotalMatched($betfairMarketStore.marketTotalMatched)}</td
>
